import Column from '@components/column'
import Button from '@components/button'
import Fields from '@components/fields'
import Container from '@components/container'
import { Formik, Form } from 'formik'
import { useState, FC } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import AccountForm from '../account'
import InstitutionStep2Form from './step2'
import { AuthSchema } from '@validations'
import { User } from '@apis'
import { Helper } from '@utils'
import { StyleAuthCard, StyleAuthCardWrapper, StyleColumn } from '../style'
import AuthHeader from '../../components/header'
interface Step {
  title?: string
  tag: string
  description?: string
  Component: FC<any>
  validationSchema?: any
}
const InstitutionForm = () => {
  const { state } = useLocation()
  const navigate = useNavigate()
  const [step, setStep] = useState<number>(1)
  const [loading, setLoading] = useState<boolean>(false)
  const [initialValues] = useState({
    name: '',
    phoneNo: state.phoneNo,
    countryCode: state?.countryCode || 977,
    email: state.email || '',
    address: '',
    password: '',
    confirmPassword: '',
    gender: '',
    departments: [],
    specializations: [],
    serviceArea: '',
    yos: '',
    avatar: '',
    coverImage: '',
    serviceIncludes: [],
    instituteType: '',
  })
  const totalStep: number = 2
  const steps: Step[] = [
    {
      title: 'Complete your',
      tag: 'Supachar Profile',
      description: 'Connecting You to What Matters',
      Component: AccountForm,
      validationSchema: AuthSchema.registerValidationSchema,
    },
    {
      title: 'Complete your',
      tag: 'Supachar Profile',
      description: 'Connecting You to What Matters',
      Component: InstitutionStep2Form,
      validationSchema: AuthSchema.institutionStep2ValidationSchema,
    },
  ]
  const { title, tag, description, Component, validationSchema } =
    steps[step - 1]

  const submitHandler = async (values: any) => {
    const payload: any = {
      name: values?.name,
      phoneNo: values?.phoneNo,
      countryCode: values?.countryCode,
      password: values?.password || Helper.generateRandomPassword(),
      email: values?.email,
      token: state?.token,
      role: 'institution',
      infos: {
        yos: values?.yos,
        address: values?.address,
        instituteType: values?.instituteType,
      },
    }
    if (!!values?.serviceIncludes || values?.serviceIncludes?.length) {
      payload.infos = {
        ...payload.infos,
        serviceIncludes: values?.serviceIncludes,
      }
    }
    if (values?.avatar?.base64) {
      payload.avatar = {
        base64: values?.avatar?.base64,
        extension: values?.avatar?.extension,
      }
    }
    if (values?.coverImage?.base64) {
      payload.infos = {
        ...payload.infos,
        coverImage: {
          base64: values?.coverImage?.base64,
          extension: values?.coverImage?.extension,
        },
      }
    }
    if (!!values?.departments) {
      payload.departments = values.departments
    }

    if (!!values?.specializations?.length) {
      payload.specializations = values.specializations?.map(
        (specialization) => specialization.id,
      )
    }
    setLoading(true)
    if (step == totalStep) {
      await User.register({
        data: payload,
      })
        .then(async (resp) => {
          await Helper.saveUser(resp)
          navigate(`/${resp?.role}`)
        })
        .catch(() => {})
    } else {
      setStep(step + 1)
    }
    setLoading(false)
  }

  return (
    <Column styleColumn="padding:30px 20px;">
      <Container>
        <Formik
          enableReinitialize
          initialValues={initialValues}
          onSubmit={submitHandler}
          validationSchema={validationSchema}
        >
          {({ handleSubmit, values, setFieldValue, errors }) => {
            return (
              <Form onSubmit={handleSubmit}>
                <AuthHeader title={title} tag={tag} subTitle={description} />

                <StyleColumn>
                  {step == 2 && (
                    <Column styleColumn="margin-bottom:60px;position:relative;">
                      <Fields.Upload
                        varient="banner"
                        name="coverImage"
                        size={200}
                      />
                      <Fields.Upload
                        varient="avatar"
                        name="avatar"
                        size={80}
                        styleWrapper="position:absolute;bottom:-40px;"
                      />
                    </Column>
                  )}
                  <StyleAuthCard>
                    <StyleAuthCardWrapper>
                      <Component
                        setFieldValue={setFieldValue}
                        values={values}
                        errors={errors}
                      />
                    </StyleAuthCardWrapper>
                  </StyleAuthCard>
                  {step == 1 && <Column></Column>}
                  <Column styleColumn="margin-top:20px">
                    <Button
                      title={step == totalStep ? 'Submit' : 'Next'}
                      type="submit"
                      bg="primary"
                      height={45}
                      styleButton="width:100%"
                      loading={loading}
                    />
                  </Column>
                </StyleColumn>
              </Form>
            )
          }}
        </Formik>
      </Container>
    </Column>
  )
}

export default InstitutionForm
